// @flow
import React, { Component } from 'react';

import ValidateText from './ValidateText.jsx';

/*
  Text field that cannot be empty.
*/

type Props = {
  field: string,
  initialValue?: ?string,
}

class RequiredText extends Component<Props> {
  render() {
    const { field, initialValue, ...rest } = this.props;
    return <ValidateText
      field={this.props.field}
      initialValue={this.props.initialValue}
      regex={/^.+$/}
      errorText={'This field is required'}
      {...rest}
    />;
  }
}

export default RequiredText;



// WEBPACK FOOTER //
// ./client/src/components/RequiredText.jsx